import React, { useState, useEffect } from 'react';
import './navbar.css';
import { useLocation } from "react-router-dom";
import axios from "axios";
import Monitor_gestione_ore_stage from "./Monitor_x1_stage.jsx";
import { Button, Table } from 'react-bootstrap';
//import { BiCalendarEdit } from 'react-icons/bi';
import Segna_presenza_assenza from "./Monitor_x2_segna_presenza.jsx";
import useWindowDimensions from '../funzioni_comuni_windows';
import { GrEdit } from "react-icons/gr";
import { LuSave,LuUndo } from "react-icons/lu";
import Feedback_della_ditta from "./Monitor_x3_feedback_ditta.jsx";
import {QRCodeSVG} from 'qrcode.react';
import JSONPretty from 'react-json-pretty';
import { IoIosLink } from 'react-icons/io'; 


const { Data_formattata1 } = require('../Funzioni_comuni_data_formattata')

function check_variabili_oggetto(obj, ...args) {
    return args.reduce((obj, level) => obj && obj[level], obj)
}

const Monitor = (props) => {

    const search = useLocation().search;
    const attore = new URLSearchParams(search).get('attore');
    const id = new URLSearchParams(search).get('id');
    const indice = new URLSearchParams(search).get('indice');
    const valore = new URLSearchParams(search).get('valore');
    const riferimento_data = new URLSearchParams(search).get('riferimento_data');
     const pdf = new URLSearchParams(search).get('pdf');
     const [progetto, SET_progetto] = useState({});
     const [disabled_pdf, SET_disabled_pdf] = useState(false);
   
  
    const width_schermo_piccolo =768
//    const [variab_aggiorna, SET_variab_aggiorna] = useState('');

    const [input, SET_input] = useState('');
    const [giornata_selezionata, SET_giornata_selezionata] = useState('');
    const { height, width } = useWindowDimensions();
 
    const orario1 = [{indice_orario: 7, orario: '7:00'},  {indice_orario:  7.5, orario: '7:30'}, 
                     {indice_orario: 8, orario: '8:00'},  {indice_orario:  8.5, orario: '8:30'}, 
                     {indice_orario: 9, orario: '9:00'},  {indice_orario:  9.5, orario: '9:30'}, 
                     {indice_orario: 10, orario: '10:00'}, {indice_orario: 10.5, orario: '10:30'}, 
                     {indice_orario: 11, orario: '11:00'}, {indice_orario: 11.5, orario: '11:30'}, 
                     {indice_orario: 12, orario: '12:00'}, {indice_orario: 12.5, orario: '12:30'},
                     {indice_orario: 13, orario: '13:00'} ]
    const orario2 = [{indice_orario: 14, orario: '14:00'}, {indice_orario: 14.5, orario: '14:30'}, 
                     {indice_orario: 15, orario: '15:00'}, {indice_orario: 15.5, orario: '15:30'}, 
                     {indice_orario: 16, orario: '16:00'}, {indice_orario: 16.5, orario: '16:30'}, 
                     {indice_orario: 17, orario: '17:00'}, {indice_orario: 17.5, orario: '17:30'}, 
                     {indice_orario: 18, orario: '18:00'}, {indice_orario: 18.5, orario: '18:30'},
                     {indice_orario: 19, orario: '19:00'}]
    
    const radios = [
        { name: 'Radio', value: '2' },
        { name: 'Radio', value: '3' },
    ];

    useEffect(() => {

        axios.patch('/progetti/progetto_push_day_presenza/' + id + '/' + attore + '/' + indice 
                                                            + '/' + valore + '/' + riferimento_data)
            .then((res) => {
                console.log('then senza errori')

                console.log(res.data)

//                SET_variab_aggiorna(JSON.stringify(res.data))
                carica_progetto()
            }).catch((error) => {
                console.log(error)
                console.log('then senza errori')
            });
    }, [id]);



    const carica_progetto = () => {
        axios.get('/progetti/trova_progetto/' + id)
        .then((res) => {
            console.log('/progetti/trova_progetto/')
//            console.log(res.data)
            SET_progetto(res.data)
            console.log('XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX')
            console.log(res.data.presenze)
            SET_input(prevInput => {
                return {
                    ...prevInput,
                    ['id_progetto']: res.data._id
                }
            })
        }).catch((error) => {
            console.log(error)
        });

    }

    const Scarica_pdf = (indirizzo) => {
        const cognome = 'prova'  
       
        axios.get('/progetti/documento_puppeter_pdf_ottieni_url/' + progetto._id + '/' + progetto.id_alunno.cognome 
                                                                  + '/' + progetto.id_alunno.nome + '/foglio_ore_progetto' )
            .then((res) => {
                console.log('xxxxxxxxxxxxxxxxx url ottenuti dal router')
                console.log(res.data)
                const newWindow = window.open(res.data, '_blank', 'noopener,noreferrer')

                if (newWindow) newWindow.opener = null

                //  return res.data

            }).catch((error) => {
                console.log('ottieni_url url errore')
                console.log(error)
            });
    };

    const aggiorna_giornata = (item_giorno) => {

        console.log(input)
        SET_giornata_selezionata(item_giorno._id)

        SET_input(prevInput => {
            return {
                ...prevInput,
                ['id_array_presenze']: item_giorno._id,
                ['data1']: item_giorno.data1,

                ['orario_mattina_in']: item_giorno.orario_mattina_in,
                ['orario_mattina_out']: item_giorno.orario_mattina_out,
                ['orario_pomerig_in']: item_giorno.orario_pomerig_in,
                ['orario_pomerig_out']: item_giorno.orario_pomerig_out,
                ['alunno1']: item_giorno.alunno1,
                ['alunno2']: item_giorno.alunno2

            }
            })
         
//          console.log(giornata_selezionata)
    }

    const salva_giornata = (item_giorno) => {
        let progetto_aux = progetto
        console.log(input)
//        console.log(progetto_aux)
        Object.keys(progetto_aux.presenze).forEach((el) => {
            if (progetto_aux.presenze[el]._id === input.id_array_presenze) {
                progetto_aux.presenze[el] = input;
            }
        });

          axios.patch('/progetti/aggiorna_giornata_nuovo', input)
        .then((res) => {
//      console.log('Aggiunta una classe')
        }).catch((error) => {
            console.log('errore')
        });

        axios.patch('/progetti/aggiorna_giornata_somma_ore', progetto_aux)
        .then((res) => {
            
            progetto_aux.presenze_somma_ore = res.data.calcolo_ore
            SET_progetto(progetto_aux)
            SET_giornata_selezionata('')
 
            
            console.log('Aggioranta la somma ore')
            console.log(res.data)
        }).catch((error) => {
            console.log('errore')
        });
//      console.log(input)
    }


    const annulla_giornata = (item_giorno) => {
        SET_giornata_selezionata('')
    
//        console.log(input)
    }

    
    return (
        <div className="container">

        {/* <JSONPretty data={progetto} /> */} 
  

          
        {!pdf &&  <div className= 'd-flex flex-row-reverse justify-content-between'>
            {pdf}
            <div className= 'd-flex flex-column '>
    
 

            <Button  disabled={disabled_pdf} onClick={Scarica_pdf}>
                Scarica PDF per Timbro e firma
            </Button>
            </div>
            <div className= 'd-flex flex-row'>
                width: {width} ~ height: {height}
            </div> 
 
        </div>}

        {width >= width_schermo_piccolo && 
        <div className= 'd-flex justify-content-between'>
            <QRCodeSVG value= {'/#/url_qrcode?doc=P1&id=' + progetto._id }/>
            <div className= 'd-flex flex-column '>
                <div>
                Inizio:  {Data_formattata1(progetto.data_inizio)} 
                </div>
                <div>
                Fine: {Data_formattata1(progetto.data_fine)}
                </div>
            </div> 
       
            <div className= 'd-flex flex-row '>
                
            <div className= 'd-flex flex-column '>
     
            {progetto != undefined && progetto.id_ditta != undefined && <>
                    <h4> {progetto.id_ditta.ragione_sociale} </h4>
                    <h4> PIVA {progetto.id_ditta.partita_iva} </h4>
                    <h4> {progetto.id_ditta.ditta_indirizzo_via} {' n. '} {progetto.id_ditta.ditta_indirizzo_civico} </h4>
                    
                    <h4> {progetto.id_ditta.ditta_indirizzo_citta} </h4>
                    </>}

            </div> 
            <div className= 'd-flex flex-column '>
            <h2> {'  '} <IoIosLink color='black' /> {'  '} </h2>    
            </div> 
     
            <div className= 'd-flex flex-column '>
      
            {progetto != undefined && progetto.id_alunno != undefined && <>
                    <h4> Alunno </h4>
             
                    <h4> {progetto.id_alunno.cognome} </h4>
                    <h4> {progetto.id_alunno.nome} </h4>
                    </>}

                </div> 
     
            </div> 

           
        </div> }
        

        {attore != null && attore.includes('ditta') && <h3>ingresso della ditta </h3>}




      

        <div className= 'd-flex flex-row-reverse'>
      
        <h6> Calcolo Ore: {progetto.presenze_somma_ore}</h6>
        </div>   

  
        {width >= width_schermo_piccolo && <Table striped bordered hover>
            <thead>
                <tr>
                <th>Giorno</th>
                <th>Periodo</th>
                <th>Appello Ditta</th>
          
                <th>Appello Alunno</th>
                <th>Ingresso</th>
                <th>Uscita</th>
           
                </tr>
            </thead>
            <tbody>
                      
            {Array.isArray(progetto.presenze) && progetto.presenze.slice(0).reverse().map (function (item1, index2) {
                {

                       
                return <> 

                <tr>

                <td rowspan='2'>{Data_formattata1(item1.data1)} {' '} {} </td>
                <td><h6> Mattina</h6> </td>
      
                <td><Feedback_della_ditta  attore={attore}  id_progetto = {progetto._id} parametro_passato= {'ditta1'} evento = {'Mattina'} id_array_presenze = {item1._id} risposta_della_ditta = {item1.ditta1} /> </td>
                <td>
                    <Segna_presenza_assenza evento = {'Mattina'}  variabile_presenza_fissa ={item1.alunno1} 
                                             variabile_presenza ={input.alunno1} 
                                            giornata_da_modificare = {giornata_selezionata == item1._id}
                                            SET_input = {SET_input}
                                            data_sulla_riga = {item1.data1}
                                           
                                            parametro_passato = {'alunno1'} />
                </td>
                <td>

                    <Monitor_gestione_ore_stage progetto_id={id} evento = {''}
                                                SET_input = {SET_input}
                                                input_ridotto = {item1.orario_mattina_in}  
                                                presenza_alunno = {input.alunno1}
                                                parametro_passato = {'orario_mattina_in'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                    orario={orario1}/>
                    
                </td>
                <td>
                    <Monitor_gestione_ore_stage progetto_id={id} evento = {''}
                                                SET_input = {SET_input}
                                                input_ridotto = {item1.orario_mattina_out}
                                                presenza_alunno = {input.alunno1}
                                                parametro_passato = {'orario_mattina_out'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                orario={orario1}/>

                </td>
                <td rowspan='2'> {giornata_selezionata == '' && index2 < 3 && !pdf && 
                         <div className= 'd-flex flex-row-reverse justify-content-center align-items-center align-self-center'>
            
                            <Button onClick={() => aggiorna_giornata(item1)} 
                                    variant="outline-primary" disabled={false} > {<GrEdit size='1.6rem' />} </Button>
                        </div> 
                    }
                    
                    {giornata_selezionata == item1._id &&                         
                        <div className= 'd-flex flex-row justify-content-center align-items-center align-self-center'>
 
                        <Button onClick={() => annulla_giornata()} disabled={false} 
                                                variant="outline-primary"> <LuUndo size='1.6rem' /> </Button> 

                        <Button onClick={() => salva_giornata()} disabled={!(input.orario_pomerig_out != undefined && 
                                                                        input.orario_pomerig_in != undefined && 
                                                                        input.orario_mattina_in != undefined &&
                                                                        input.orario_mattina_out != undefined)  
                                                                        } 
                                                                        variant="outline-primary"> <LuSave size='1.6rem'/> </Button>
                        </div> 
                    }
                </td>
                </tr>
                <tr>
                <td><h6> Pomeriggio </h6> </td>
      
                <td> <Feedback_della_ditta  attore={attore}  id_progetto = {progetto._id} parametro_passato= {'ditta2'} evento = {'Pomeriggio'} id_array_presenze = {item1._id} risposta_della_ditta = {item1.ditta2} /> </td>
              
                <td>
                    <Segna_presenza_assenza evento = {'Pomeriggio'} variabile_presenza ={input.alunno2} 
                                            variabile_presenza_fissa ={item1.alunno2}
                                            giornata_da_modificare = {giornata_selezionata == item1._id}
                                            SET_input = {SET_input}        
                                            data_sulla_riga = {item1.data1}
                                            
                                            parametro_passato = {'alunno2'}
                                            />
                    
                </td>
                <td>
                    
                    <Monitor_gestione_ore_stage progetto_id={id} 
                                                SET_input = {SET_input} evento = {''}
                                                input_ridotto = {item1.orario_pomerig_in}
                                                presenza_alunno = {input.alunno2}
                                                parametro_passato = {'orario_pomerig_in'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                orario={orario2}/>
                                                
                </td>
                <td>
                  
    
                    <Monitor_gestione_ore_stage progetto_id={id}
                                                SET_input = {SET_input} evento = {''}
                                                input_ridotto = {item1.orario_pomerig_out} 
                                                presenza_alunno = {input.alunno2}
                                                parametro_passato = {'orario_pomerig_out'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                orario={orario2}/>
                </td>
                </tr>
                </>
                
                }
            })
           

            }
            </tbody>
            </Table>
            }




            {width < width_schermo_piccolo && <Table striped bordered hover>
   
            <tbody>
                      
            {Array.isArray(progetto.presenze) && progetto.presenze.slice(0).reverse().map (function (item1, index2) {
                {

                       
                return <> 
                {1 ==1 && <tr>

                <td>
                {attore != null && attore.includes('ditta') && 
                        <small> Ditta </small> }
                </td>
                
                <td colspan='3' class={giornata_selezionata == item1._id ?  "table-secondary" : "table-primary"} >
                    <div className= 'd-flex flex-row-reverse align-items-center align-self-center'>    
                    {Data_formattata1(item1.data1)}  

                    {giornata_selezionata == '' && index2 < 3 && 
                         <div >
            
                            <Button onClick={() => aggiorna_giornata(item1)} 
                                    variant="outline-primary" disabled={false} > {<GrEdit />} </Button>
                        </div> 
                    }
                    {giornata_selezionata == item1._id &&                         
                        <div className= 'd-flex flex-row justify-content-center align-items-center align-self-center'>
 
                        <Button onClick={() => annulla_giornata()} disabled={false} 
                                                 variant="outline-primary"> <LuUndo /> </Button> 

                        <Button onClick={() => salva_giornata()} disabled={!(input.orario_pomerig_out != undefined && 
                                                                        input.orario_pomerig_in != undefined && 
                                                                        input.orario_mattina_in != undefined &&
                                                                        input.orario_mattina_out != undefined)  
                                                                        } 
                                                                        variant="outline-primary"> <LuSave /> </Button>
                        </div> 
                    }
                    </div>
                </td>
               
                </tr> }
              
                <tr>
             
                {attore != null && attore.includes('ditta') && <td>
                <Feedback_della_ditta  attore={attore}  id_progetto = {progetto._id} parametro_passato= {'ditta1'} evento = {'Mattina'} id_array_presenze = {item1._id} risposta_della_ditta = {item1.ditta1} />  
                </td>}
                <td>
                    <Segna_presenza_assenza evento = {'Mattina'}  variabile_presenza_fissa ={item1.alunno1} 
                                             variabile_presenza ={input.alunno1} 
                                            giornata_da_modificare = {giornata_selezionata == item1._id}
                                            SET_input = {SET_input}
                                            data_sulla_riga = {item1.data1}
                                            parametro_passato = {'alunno1'} />
                                            <small> mattina </small>
                </td>
                <td>

                    <Monitor_gestione_ore_stage progetto_id={id} evento = {''}
                                                SET_input = {SET_input}
                                                input_ridotto = {item1.orario_mattina_in}  
                                                presenza_alunno = {input.alunno1}
                                                parametro_passato = {'orario_mattina_in'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                orario={orario1}/>
                </td>
                <td>
                    <Monitor_gestione_ore_stage progetto_id={id} evento = {''}
                                                SET_input = {SET_input}
                                                input_ridotto = {item1.orario_mattina_out}
                                                presenza_alunno = {input.alunno1}
                                                parametro_passato = {'orario_mattina_out'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                orario={orario1}/>
                </td>
                </tr>
                <tr>
                {attore != null && attore.includes('ditta') && <td>
                <Feedback_della_ditta  attore={attore}  id_progetto = {progetto._id} parametro_passato= {'ditta2'} evento = {'Pomeriggio'} id_array_presenze = {item1._id} risposta_della_ditta = {item1.ditta2} />  
                </td>}
               
                <td>
                    <Segna_presenza_assenza evento = {'Pomeriggio'} variabile_presenza ={input.alunno2} 
                                            variabile_presenza_fissa ={item1.alunno2}
                                            giornata_da_modificare = {giornata_selezionata == item1._id}
                                            SET_input = {SET_input}        
                                            data_sulla_riga = {item1.data1}
                                            parametro_passato = {'alunno2'}
                                            />
                                            <small> Pomeriggio </small>

                </td>
                <td>
                    <Monitor_gestione_ore_stage progetto_id={id} 
                                                SET_input = {SET_input} evento = {''}
                                                input_ridotto = {item1.orario_pomerig_in}
                                                presenza_alunno = {input.alunno2}
                                                parametro_passato = {'orario_pomerig_in'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                orario={orario2}/>
                </td>
                <td>
                    <Monitor_gestione_ore_stage progetto_id={id}
                                                SET_input = {SET_input} evento = {''}
                                                input_ridotto = {item1.orario_pomerig_out} 
                                                presenza_alunno = {input.alunno2}
                                                parametro_passato = {'orario_pomerig_out'}
                                                giornata_da_modificare = {giornata_selezionata == item1._id}
                                                orario={orario2}/>
                </td>
                </tr>
                </>
                }
            })
            }
            </tbody>
            </Table>
            }
   
            {/*             <h4>Grazie per la risposta</h4>
            <p>{id} - {attore} - {indice} - {valore} </p>
            <p>{riferimento_data}</p>
             */}      
            {pdf &&  <div className= 'd-flex flex-row-reverse '> 
                <div className= 'd-flex flex-column'>
                    
                    <p>Firma e Timbro Ditta</p> <p>
                        _____________________
                    </p>
                </div>
                </div>
            }  

        {(props.account_dati.utente_debug) &&  <JSONPretty data={progetto} /> }

                            
        </div>
    );
}
export default Monitor;